import React, { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

// routes config
import routes from "../AppContent/Route";
import HRroutes from "../AppContent/HRroutes";
import Type4Routes from '../AppContent/HRroutes'
import CompanyShares from "../AppContent/CompanyURl";

const loading = (
    <div className="loading">
        <div className="spinner-grow text-danger" role="status"></div>
    </div>
);


const AppContent = () => {
    const type = atob(sessionStorage.getItem('type'));
    console.log(type)


    return (
        <div className="container-fluid main_wrapper h-100 p-lg-3 p-md-2 p-sm-2">
            <Suspense fallback={loading}>
                <Routes>
                    {type == '2' ? (
                        CompanyShares.map((route, idx) => {
                            return (
                                route.element && (
                                    <Route
                                        key={idx}
                                        path={route.path}
                                        exact={route.exact}
                                        name={route.name}
                                        element={<route.element />}
                                    />
                                )
                            );
                        })
                    ) : type == 4 ? (
                        HRroutes.map((route, idx) => {
                            return (
                                route.element && (
                                    <Route
                                        key={idx}
                                        path={route.path}
                                        exact={route.exact}
                                        name={route.name}
                                        element={<route.element />}
                                    />
                                )
                            );
                        })
                    ) : (
                        routes.map((route, idx) => {
                            return (
                                route.element && (
                                    <Route
                                        key={idx}
                                        path={route.path}
                                        exact={route.exact}
                                        name={route.name}
                                        element={<route.element />}
                                    />
                                )
                            );
                        })
                    )}


                    <Route path="/" element={<Navigate to="dashboard" replace />} />
                </Routes>
            </Suspense>
        </div>
    );
};

export default React.memo(AppContent);
